import { OLIVEOILS_SERVICE } from "@/services/oliveOils.service.js";

const state = {postOliveOilOutput: false, getOliveOilsOutput: {}, putOliveOilOutput: false, getOliveOilDetailsOutput: {}, deleteOliveOilByIdOutput: false, getOliveOilBySlugOutput: {}};

const actions = {
    //Service to create oliveOils
    postOliveOil({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postOliveOilRequest');
        
        OLIVEOILS_SERVICE.postOliveOil(input)
            .then(
                output => {
                    commit('postOliveOilSuccess', output);
                },
                error => {
                    commit('postOliveOilFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated oliveOils
    getOliveOils({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getOliveOilsRequest');

        OLIVEOILS_SERVICE.getOliveOils(queryParams)
            .then(
                output => {
                    commit('getOliveOilsSuccess', output);
                },
                error => {
                    commit('getOliveOilsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update oliveOils
    putOliveOil({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putOliveOilRequest');

        OLIVEOILS_SERVICE.putOliveOil(input)
            .then(
                output => {
                    commit('putOliveOilSuccess', output);
                },
                error => {
                    commit('putOliveOilFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get oliveOil details
    getOliveOilDetails({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getOliveOilDetailsRequest');

        OLIVEOILS_SERVICE.getOliveOilDetails(queryParams)
            .then(
                output => {
                    commit('getOliveOilDetailsSuccess', output);
                },
                error => {
                    commit('getOliveOilDetailsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete oliveOils
    deleteOliveOilById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteOliveOilByIdRequest');

        OLIVEOILS_SERVICE.deleteOliveOilById(id)
            .then(
                output => {
                    commit('deleteOliveOilByIdSuccess', output);
                },
                error => {
                    commit('deleteOliveOilByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postOliveOil
    postOliveOilRequest(state) {
        state.postOliveOilOutput = null;
    },
    postOliveOilSuccess(state, output) {
        state.postOliveOilOutput = true;
    },
    postOliveOilFailure(state) {
        state.postOliveOilOutput = false;
    },

    //getOliveOils
    getOliveOilsRequest(state) {
    },
    getOliveOilsSuccess(state, output) {
        state.getOliveOilsOutput = output;
    },
    getOliveOilsFailure(state) {
        state.getOliveOilsOutput = false;
    },

    //putOliveOil
    putOliveOilRequest(state) {
        state.putOliveOilOutput = null;
    },
    putOliveOilSuccess(state, output) {
        state.putOliveOilOutput = true;
    },
    putOliveOilFailure(state) {
        state.putOliveOilOutput = false;
    },

    //getOliveOilDetails
    getOliveOilDetailsRequest(state) {
    },
    getOliveOilDetailsSuccess(state, output) {
        state.getOliveOilDetailsOutput = output;
    },
    getOliveOilDetailsFailure(state) {
        state.getOliveOilDetailsOutput = false;
    },

    //deleteOliveOilById
    deleteOliveOilByIdRequest(state) {
        state.deleteOliveOilByIdOutput = null;
    },
    deleteOliveOilByIdSuccess(state, output) {
        state.deleteOliveOilByIdOutput = true;
    },
    deleteOliveOilByIdFailure(state) {
        state.deleteOliveOilByIdOutput = false;
    },
};

export const oliveOils = {
    namespaced: true,
    state,
    actions,
    mutations
};